import React from 'react';
import {
  List,
  Datagrid,
  TextField,
} from 'react-admin';

const PrestacionesList = (props) => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="descripcion" />
      <TextField source="precioCosto" />
    </Datagrid>
  </List>
);

export default PrestacionesList;
